import { useQuery } from "react-query";
import {
  GetDataByTermsRequest,
  GetBodyWeightRecordsResponse,
  PatientBodyWeightRecords,
} from "types";
import { get } from "lib/axios";
import { useQueryClient } from "react-query";
import { useEffect } from "react";
import { formatDateToString } from "utils";

const getPatientBodyWeightRecords = async (
  patientId: string,
  params: GetDataByTermsRequest
): Promise<PatientBodyWeightRecords> => {
  const { data } = await get<GetBodyWeightRecordsResponse>(
    `/patients/${patientId}/health_record/body_weight/daily`,
    {
      params: {
        from_date: formatDateToString(params.from_date),
        to_date: formatDateToString(params.to_date),
      },
    }
  );

  return data.values.map((data) => {
    return [Date.parse(data.date), data.value];
  });
};

export const usePatientBodyWeightRecordsQuery = (
  patientId: string,
  params: GetDataByTermsRequest
) => {
  return useQuery(
    [`healthRecord/bodyWeight`],
    () => {
      return getPatientBodyWeightRecords(patientId, params);
    },
    {
      retry: false,
      staleTime: 1000 * 60 * 5,
    }
  );
};

export const useRemoveCacheOnUnMount = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      queryClient.removeQueries("healthRecord/bodyWeight");
    };
  }, [queryClient]);
};
